import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Filters } from '../types/filter.types';

interface FilterContextType {
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  resetFilters: () => void;
}

const FilterContext = createContext<FilterContextType | undefined>(undefined);

interface FilterProviderProps {
  children: ReactNode;
  initialFilters?: Filters;
}

export const FilterProvider: React.FC<FilterProviderProps> = ({
  children,
  initialFilters = {
    activities: ['skitouring'],
    skitouring: undefined,
  },
}) => {
  const [filters, setFilters] = useState<Filters>(initialFilters);

  const resetFilters = () => {
    setFilters({
      activities: filters.activities,
      skitouring: undefined,
    });
  };

  return (
    <FilterContext.Provider value={{ filters, setFilters, resetFilters }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = (): FilterContextType => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilterContext must be used within FilterProvider');
  }
  return context;
};
